import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-isalni',
  standalone: true,
  imports: [FormsModule, CommonModule, TranslateModule],
  templateUrl: './isalni.component.html',
  styleUrl: './isalni.component.css'
})
export class IsalniComponent {
  private readonly apiBaseUrl = environment.apiUrl.replace(/\/$/, '');
  question: string = '';
  response: string = '';
  isLoading: boolean = false;

  constructor(private http: HttpClient, private translate: TranslateService) { }

  submitQuestion() {
    if (this.question.trim()) {
      this.isLoading = true;
      const requestBody = { question: this.question };
      this.http.post<any>(`${this.apiBaseUrl}/isalni/ask`, requestBody) // Removed responseType: 'text'
        .subscribe({
          next: (res) => {
            if (res && res.error === 'null') {
              this.response = res.response;
            } else {
              this.response = res.error || this.translate.instant('isalni.errorResponse');
            }
            this.isLoading = false;
          },
          error: (err) => {
            console.error('Error calling Isalni API:', err);
            this.response = this.translate.instant('isalni.errorResponse');
            this.isLoading = false;
          }
        });
    } else {
      this.response = this.translate.instant('isalni.enterQuestion');
    }
  }
}
